/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 11:26:10
 * @LastEditors: caiqin.xie
 * @message: 产品支持-产品banner
 */
import React from "react";
import { getFileExtension } from '@/common/untils'
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"
import { IProduct } from "@/common/types";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  product: IProduct; // 产品信息
}

const ProductBanner = (props:IProps) => {
  const {ctry, words, product} = props
  
  return (
    <>
      {product && (
        <div className={styles['product-banner']}> 
          <div className={styles['banner-img']}>
            {product && product.cover && (
              getFileExtension(product.cover) === 'mp4'
              ? <LazyMedia type="video" LazyClassName="full-wh" loop autoPlay preload="auto" playsInline muted src={product?.cover}/>
              : <LazyMedia type="image" LazyClassName="full-wh" src={product?.cover} alt={product?.coverAlt} />
            )}
          </div>
          <div className={styles['banner-content']}>
            <h3>{words?.support_product_technical_support}</h3>
            {/* Technical support */}
            {product?.id && (
              <a href={`/${ctry}/support/product-parameter/${product.id}`}>
                <span className={styles['banner-btn']}>{words?.support_product_technical_parameter}</span>
              </a>
            )}
            {/* Technical Parameter */}
          </div>
        </div>
      )}
    </>
  )
}
export default ProductBanner